import icon from 'vue-svgicon';

icon.register({
    'regular/car-1': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M21.75 17a1.5 1.5 0 0 0 1.5-1.5v-2.251a1.811 1.811 0 0 0-.53-1.279L20.25 9.5H3.75l-2.47 2.47a1.811 1.811 0 0 0-.53 1.279V15.5a1.5 1.5 0 0 0 1.5 1.5z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" d="M.912 12.5h3.717a1.5 1.5 0 0 1 1.06.439L6.75 14M23.088 12.5h-3.717a1.5 1.5 0 0 0-1.06.439L17.25 14M3.75 9.5l1.7-4.54A2.249 2.249 0 0 1 7.559 3.5h8.882a2.249 2.249 0 0 1 2.106 1.46l1.7 4.54zM3.75 9.5L2.25 8H.75M20.25 9.5l1.5-1.5h1.5M2.25 17v1.5a1.5 1.5 0 0 0 3 0V17zM21.75 17v1.5a1.5 1.5 0 0 1-3 0V17z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
